import { cn } from "@/lib/utils";

interface LoadingProps {
  fullScreen?: boolean;
  className?: string;
}

export function Loading({ fullScreen, className }: LoadingProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        fullScreen && "min-h-screen",
        className,
      )}
    >
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
    </div>
  );
}
